// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__8hb1O","content":"GlobalSearch_content__1T3gf"};